import { render, staticRenderFns } from "./storeEdit.vue?vue&type=template&id=4f09880c&scoped=true"
import script from "./storeEdit.vue?vue&type=script&lang=js"
export * from "./storeEdit.vue?vue&type=script&lang=js"
import style0 from "./storeEdit.vue?vue&type=style&index=0&id=4f09880c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f09880c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城商家端\\fhj-web-dyh-mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f09880c')) {
      api.createRecord('4f09880c', component.options)
    } else {
      api.reload('4f09880c', component.options)
    }
    module.hot.accept("./storeEdit.vue?vue&type=template&id=4f09880c&scoped=true", function () {
      api.rerender('4f09880c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/components/storeEdit.vue"
export default component.exports